import React from 'react';

const ActionButton = ({ isRenovacao, isLoading, handleClick, copyDados, carteira }) => {
  const commonClassName = "flex items-center justify-center rounded-lg text-xl bg-red-600 text-white font-league-gothic border-none cursor-pointer text-center box-border mb-1";

  if (isRenovacao) {
    return (
      <button
        className={commonClassName}
        disabled={isLoading}
        onClick={() => handleClick(carteira)}
      >
        RENOVAÇÃO{" "}
      </button>
    );
  }

  return (
    <button
      className={commonClassName}
      onClick={() => copyDados(carteira)}
    >
      {" "}
      DADOS{" "}
    </button>
  );
};

export default ActionButton;
